import { faker } from '@faker-js/faker'
import { format, addYears, subYears } from 'date-fns'
import { Factory } from 'miragejs'
import { isAfter } from 'date-fns'

export default Factory.extend({
  studentCount: 50,
  softCapacity: '90',
  startDate() {
    return format(subYears(new Date(), 1), 'yyyy-MM-dd')
  },

  endDate() {
    return format(addYears(new Date(), 1), 'yyyy-MM-dd')
  },

  // this logic isn't exactly the same as backend - their date comparisons are UTC and likely coerce the date comparison
  // to be dates (ignoring time), inclusive of start/end date. Approximate is good enough for our tests.
  status() {
    const now = new Date()
    const start = new Date(this.startDate)
    const end = new Date(this.endDate)
    if (isAfter(now, end)) return 'expired'
    if (isAfter(now, start)) return 'active'
    return 'pending'
  },

  subscriptionType() {
    return faker.helpers.arrayElement(['reading', 'maths'])
  },
})
